import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="multistyle-dateselect"
export default class extends Controller {
  static targets = [ "input", "select", "option" ]
  connect() {
    this.change_select()
  }

  change_select() {
    if (this.selectTarget.value === 'no_setting') {
      this.inputTargets[0].style = "display:none;"
      this.inputTargets[1].style = "display:none;"
      this.optionTarget.style = "display:none;"
    } else if (this.selectTarget.value === 'date_specification') {
      this.inputTargets[0].style = ""
      this.inputTargets[1].style = "display:none;"
      this.optionTarget.style = "display:none;"
    } else {
      this.inputTargets[0].style = "display:none;"
      this.inputTargets[1].style = ""
      this.optionTarget.style = ""
    }
  }
}
